__webpack_require__.p = "/awards/";